import ArrayPool from "./Pools/ArrayPool";

export default class Cloner {
    /**
     * Deep clone an object
     */
    public static Clone<T>(object: T): T {
        // return {...object}; // Shallow
        // return Object.assign({}, object); // Shallow
        // return JSON.parse(JSON.stringify(object)); // Takes a long time

        let clone: any;

        if(Array.isArray(object)) {
            clone = ArrayPool.Get();

            for(let i = 0, l = object.length; i < l; i++) {
                clone[i] = Cloner.Clone(object[i]);
            }
        } else if(typeof object === "object" && object !== null) {
            clone = {};

            for(const i in object) {
                if(!Object.prototype.hasOwnProperty.call(object, i)) continue;

                clone[i] = Cloner.Clone(object[i]);
            }
        } else {
            clone = object;
        }

        return clone;
    }

    /**
     * Shallow clone an object
     */
    public static Shallow<T>(object: T): T {
        return { ...object };
    }
}
